import { takeEvery, call, put } from "redux-saga/effects";
import { addNotification, setTableSelection } from "@fas/ui-framework";
import { ACTIVATE_DOCUMENT_SAGA, PAGES_LIST } from "../../helpers/constants";
import DocumentApi from "../../services/documentApi";
import type { ActivateDocumentSaga } from "../../actions/pages";
import setLoading from "../../actions/loading";
import { getPagesListSaga } from "../../actions/pages/actions";
import type { PagesListLoading as LoadingTypes } from "../../actions/loading";

export function* makeFetch(action: ActivateDocumentSaga) {
  try {
    const { documentId }: ActivateDocumentSaga = action;
    yield put(setLoading<LoadingTypes>(PAGES_LIST, true));
    yield call(DocumentApi.publishDocument, { documentId });
    yield put(getPagesListSaga());
    yield put(setTableSelection(PAGES_LIST, []));
    yield put(addNotification({ message: "Page activated", severity: "success" }));
  }
  catch (error: any) {
    yield put(addNotification({ message: error.errorMessage || "Failed to change document status", severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
  }
  finally {
    yield put(setLoading<LoadingTypes>(PAGES_LIST, false));
  }
}

export default function* watch() {
  yield takeEvery(ACTIVATE_DOCUMENT_SAGA, makeFetch);
}
